import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

export function ModalHomonimos({
  show,
  onHide,
  pacientes = [],
  nomeDigitado = '',
  onConfirmarCadastro,
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title className="h5 fw-bold">⚠️ Paciente com mesmo nome encontrado!</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-2">
          Já existe(m) paciente(s) cadastrado(s) com o nome <strong>{nomeDigitado}</strong>.
        </p>
        <p className="text-muted small">
          Confira abaixo se a pessoa já não possui cadastro na clínica antes de criar um novo
          registro:
        </p>

        <Table striped bordered hover responsive size="sm" className="mt-3">
          <thead className="table-dark">
            <tr>
              <th>Cód.</th>
              <th>Nome Completo</th>
              <th>Data Nasc.</th>
              <th>CPF</th>
            </tr>
          </thead>
          <tbody>
            {pacientes.map((pac) => (
              <tr key={pac.CODPAC}>
                <td className="fw-bold">{pac.CODPAC}</td>
                <td>{pac.NOMEPAC}</td>
                <td>
                  {pac.DTNPAC
                    ? new Date(pac.DTNPAC).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
                    : 'Não informada'}
                </td>
                <td>{pac.CPFPAC || 'Não informado'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="secondary" onClick={onHide}>
          Cancelar / Revisar
        </Button>

        <Button variant="success" onClick={onConfirmarCadastro}>
          Confirmar e Cadastrar Novo Paciente
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
